import PerformanceManagementPage from './components/PerformanceManagementPage';

export default PerformanceManagementPage;
